var map = {
	"./ca.json": [
		80827,
		827
	],
	"./de.json": [
		33116,
		116
	],
	"./es.json": [
		27297,
		297
	],
	"./fr.json": [
		83056,
		56
	],
	"./ja.json": [
		23160,
		160
	],
	"./ko.json": [
		55540,
		540
	],
	"./pt.json": [
		10188,
		188
	],
	"./ru.json": [
		97441,
		441
	],
	"./zh-cn.json": [
		2030,
		30
	],
	"./zh-tw.json": [
		4076,
		76
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 37472;
module.exports = webpackAsyncContext;